import * as React from 'react';
import { Select, Space } from 'ebs-design';
import type { OptionValue } from 'ebs-design/dist/components/molecules/Select/interfaces';
import { FiltersContext } from '../Filters';
import { SelectProps } from '../interface';

export const SelectFilter: React.FC<SelectProps> = ({
  field,
  value,
  placeholder,
  prefix,
  className,
  isClearable = true,
  mode,
  valueMode,
  disabled,
  children,
}) => {
  const { onChange } = React.useContext(FiltersContext);

  const handleChange = (v: OptionValue | OptionValue[]): void => {
    onChange({ [field]: v });
  };

  return (
    <Space className={className}>
      <Select
        className="filter-item"
        value={value}
        valueMode={valueMode}
        onChange={handleChange}
        prefix={prefix}
        placeholder={placeholder}
        isClearable={isClearable}
        mode={mode}
        disabled={disabled}
      >
        {children}
      </Select>
    </Space>
  );
};
